import { H3, Text } from '@betterment/samba-react';

import { SambaAutoLink } from '~/b4b/components/SambaAutoLink';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

export const AutoApplySetting: React.FC = () => {
  return (
    <>
      <H3 variant="title200" css={{ pb: 'space.200' }}>
        Auto apply setting
      </H3>

      <Text as="p">
        Unallocated funds are the balance of forfeiture, suspense, and cash funds that you can apply to employer
        contributions through payroll. These funds are part of your 401(k) plan's assets and aren't assigned to
        individual participant accounts. When the{' '}
        <SambaAutoLink to={urlBuilder.unallocatedFundsAutomationEdit()}>
          Auto apply unallocated funds setting
        </SambaAutoLink>{' '}
        is on, Betterment will automatically use these funds to offset your payroll amounts in accordance with 401(k)
        regulation. You can also choose to use unallocated funds as a funding source during your year-end actions. You
        can learn more about unallocated funds in our{' '}
        <SambaAutoLink target="_blank" rel="noopener noreferrer" to={urlBuilder.getUnallocatedFundsGuide()}>
          Guide to Unallocated Funds
        </SambaAutoLink>
        .
      </Text>
    </>
  );
};
